import moment from "moment";
import { DECRYPT_VALUE, ENCRYPT_VALUE } from "./Encrypt";
import { EffortEncRow } from "./Effort";
import { CatchEncRow } from "./Catch";
import { getSalesRow } from "./Sales";

export const TripEncRow = function () {
  this.trip_id = null;
  this.date_sail = null;
  this.date_land = null;
  this.number_of_anglers = null;
  this.number_of_crew = null;
  this.operator_first_name = null;
  this.operator_last_name = null;
  this.operator_middle_name = null;
  this.operator_permit_number = null;
  this.operator_ext_name = null;
  this.report_type = null;
  this.trip_type = null;
  this.vessel_name = null;
  this.vessel_permit_num = null;
  this.vessel_registration = null;
  this.no_effort_trip_reason = null;
  this.images = [];
  this.sales = [];
  this.submitted_trip = false;
  this.submitted_success = false;
  this.lowest_serial_num = null;
  this.submission_type = null;
  this.trip_status = null;
  this.buoyLines = null;
  this.trapsPerString = null;
  this.trapsInWater = null;
  this.default_uom = null;
  this.default_species_uom = null;
};
TripEncRow.prototype.setTripId = function (trip_id) {
  this.trip_id = trip_id;
};
TripEncRow.prototype.setDateSail = function (date_sail) {
  this.date_sail = date_sail;
};
TripEncRow.prototype.setDateLand = function (date_land) {
  this.date_land = date_land;
};
TripEncRow.prototype.setNoEffortTripReason = function (no_effort_trip_reason) {
  this.no_effort_trip_reason = no_effort_trip_reason;
};
TripEncRow.prototype.setNumberOfAnglers = function (number_of_anglers) {
  this.number_of_anglers = number_of_anglers;
};
TripEncRow.prototype.setNumberOfCrew = function (number_of_crew) {
  this.number_of_crew = number_of_crew;
};
TripEncRow.prototype.setOperatorFirstName = function (operator_first_name) {
  this.operator_first_name = operator_first_name;
};
TripEncRow.prototype.setOperatorLastName = function (operator_last_name) {
  this.operator_last_name = operator_last_name;
};
TripEncRow.prototype.setOperatorMiddleName = function (operator_middle_name) {
  this.operator_middle_name = operator_middle_name;
};
TripEncRow.prototype.setOperatorExtName = function (operator_ext_name) {
  this.operator_ext_name = operator_ext_name;
};
TripEncRow.prototype.setOperatorPermitNumber = function (operator_permit_number) {
  this.operator_permit_number = operator_permit_number;
};
TripEncRow.prototype.setReportType = function (report_type) {
  this.report_type = report_type;
};
TripEncRow.prototype.setTripType = function (trip_type) {
  this.trip_type = trip_type;
};
TripEncRow.prototype.setVesselName = function (vessel_name) {
  this.vessel_name = vessel_name;
};
TripEncRow.prototype.setVesselPermitNum = function (vessel_permit_num) {
  this.vessel_permit_num = vessel_permit_num;
};
TripEncRow.prototype.setVesselRegistration = function (vessel_registration) {
  this.vessel_registration = vessel_registration;
};
TripEncRow.prototype.setSubmittedTrip = function (submitted_trip) {
  this.submitted_trip = submitted_trip;
};
TripEncRow.prototype.setSubmittedSuccess = function (submitted_success) {
  this.submitted_success = submitted_success;
};
TripEncRow.prototype.setLowestSerialNum = function (lowest_serial_num) {
  this.lowest_serial_num = lowest_serial_num;
};
TripEncRow.prototype.setSubmissionType = function (submission_type) {
  this.submission_type = submission_type;
};
TripEncRow.prototype.setTripStatus = function (trip_status) {
  this.trip_status = trip_status;
};
TripEncRow.prototype.setBuoyLines = function (buoyLines) {
  this.buoyLines = buoyLines;
};
TripEncRow.prototype.setTrapsPerString = function (trapsPerString) {
  this.trapsPerString = trapsPerString;
};
TripEncRow.prototype.setTrapsInWater = function (trapsInWater) {
  this.trapsInWater = trapsInWater;
};
TripEncRow.prototype.setDefaultUOM = function (defaultUOM) {
  this.default_uom = defaultUOM;
};
TripEncRow.prototype.setDefaultSpeciesUOM = function (defaultSpeciesUOM) {
  this.default_species_uom = defaultSpeciesUOM;
};
TripEncRow.prototype.getReportType = function () {
  return this.report_type;
};
export const dateTimeSavedToDisplay = function (dateSaved) {
  if (!dateSaved) {
    return null;
  }
  const dt = moment(dateSaved, "YYMMDDHHmm");
  const dateTimeToDisplay = dt.format("DD-MMM-YY LT");
  return dateTimeToDisplay;
};
export const dateSavedToDisplay = function (dateSaved) {
  if (!dateSaved) {
    return null;
  }
  const dt = moment(dateSaved, "YYMMDD");
  const dateToDisplay = dt.format("MM-DD-YYYY");
  return dateToDisplay;
};

export const getReportType = (reportTripType, types = []) => {
  const tripType = types.find((type) => type.KEY === parseInt(reportTripType));
  return tripType ? tripType.REPORT_TYPE : "";
};

export const getTripType = (reportTripType, types = []) => {
  const tripType = types.find((type) => type.KEY === parseInt(reportTripType));
  return tripType ? String(tripType.TRIP_TYPE) : "";
};

export const getReportTripTypeKey = (reportType, tripType, types = []) => {
  const currentType = types.find(
    (type) =>
      type.REPORT_TYPE === parseInt(reportType) && type.TRIP_TYPE === parseInt(tripType)
  );
  return currentType ? currentType.KEY : "";
};

export const getDisplayTripType = function (newReportType, newTripType, types = []) {
  let display_trip_type = "";
  if (newReportType && newTripType && types && Array.isArray(types)) {
    const displayed_text = types.find(
      (type) =>
        type.REPORT_TYPE === parseInt(newReportType) &&
        type.TRIP_TYPE === parseInt(newTripType)
    );
    display_trip_type = displayed_text ? displayed_text.VALUE : "";
  }
  return display_trip_type;
};

export const getTripValuesByKey = (key, types = []) => {
  return types.find((type) => type.KEY === parseInt(key));
};

export const getTripValues = (tripType, reportType, types = []) => {
  return types.find(
    (type) =>
      type.TRIP_TYPE === parseInt(tripType) && type.REPORT_TYPE === parseInt(reportType)
  );
};

export const uomToDisplay = (uom, uomCodes = []) => {
  const uomObj = uomCodes.find((item) => item.uom_codes === uom);

  return uomObj ? uomObj.display_label : "";
};

export const handleTripPreferenceChange = function (event) {
  event.preventDefault();
  let newValue = event.currentTarget.dataset.newValue;
  let field = event.currentTarget.dataset.field;
  if (!newValue) {
    console.log("No new value provided");
    return;
  }
  if (!field) {
    console.error("No field provided");
    return;
  }

  let newState = {};
  newState[field] = newValue;
  console.info("prefchange", newState);

  this.setState(newState);
};

export const getShowCrewField = function (newTripType) {
  let showNrCrew = true;
  const tripShowCrew = [1, 2, 3, 4];
  if (newTripType && !tripShowCrew.includes(Number(newTripType))) {
    showNrCrew = false;
  }
  return showNrCrew;
};

export const getShowAnglerField = function (newTripType) {
  let showNrAnglers = true;
  const tripShowAnglers = [2, 3, 6];
  if (newTripType && !tripShowAnglers.includes(Number(newTripType))) {
    showNrAnglers = false;
  }
  return showNrAnglers;
};

export const getOperatorOptions = function (
  operator,
  entitle_permits,
  entitle_operator,
  client,
  permit = null
) {
  const localOperator = [...operator];
  const localPermitNr = permit.toString();
  // declaring the test operator object for multiple uses
  const testOperator = {
    OPERATOR_KEY: client.client_id.padStart(8, "9"),
    NAME_FIRST: "Test",
    NAME_MIDDLE: null,
    NAME_LAST: "User",
  };
  if (client.user_app_status === "TEST") {
    let testOperatorExists = false;
    if (localOperator.length > 0) {
      localOperator.find(
        (operator) =>
          (testOperatorExists =
            operator.OPERATOR_KEY === client.client_id.padStart(8, "9") ? true : false)
      );
    }
    if (!testOperatorExists) {
      localOperator.push(testOperator);
    }
    if (entitle_operator.length > 0 && !entitle_permits.includes(localPermitNr)) {
      return [testOperator];
    }
  }
  if (
    (entitle_operator.length > 0 && entitle_permits.length === 0) ||
    !entitle_permits.includes(localPermitNr)
  ) {
    const userOperator = localOperator.find(
      (operator) => parseInt(operator.OPERATOR_KEY) === parseInt(client.operator_key)
    );
    return userOperator ? [userOperator] : [];
  }
  // default value to return
  return localOperator;
};

export const getPermitOptions = function (
  permit,
  entitle_permits,
  entitle_operator,
  selected_operator
) {
  let permitOptions = [];
  if (
    entitle_operator !== null &&
    entitle_operator.length === 0 &&
    entitle_permits.length > 0
  ) {
    for (let j = 0; j < permit.length; j++) {
      if (entitle_permits.includes(permit[j].PNUM)) {
        permitOptions[permitOptions.length] = permit[j];
      }
    }
    return permitOptions;
  }
  //if operator and entitlements to a vessel, and operator chosen is
  // not your operator_key then show only the vessels your entitled to
  if (
    selected_operator &&
    entitle_permits.length > 0 &&
    entitle_operator.length === 1 &&
    selected_operator !== entitle_operator[0].OPERATOR_KEY
  ) {
    for (let j = 0; j < permit.length; j++) {
      if (entitle_permits.includes(permit[j].PNUM)) {
        permitOptions[permitOptions.length] = permit[j];
      }
    }
    return permitOptions;
  }
  return permit;
};

export const handleOperatorChange = function (event, reason) {
  console.log("operator_change_event", event);
  console.log("operator_change_reason", reason);
  if (reason) {
    if (
      reason.hasOwnProperty("OPERATOR_KEY") &&
      reason.hasOwnProperty("NAME_FIRST") &&
      reason.hasOwnProperty("NAME_MIDDLE") &&
      reason.hasOwnProperty("NAME_LAST")
    ) {
      console.log(this.props.validations.validations.permit);
      console.log(this.props.auth.vessel_entitlements);
      console.log(this.props.auth.operator_entitlements);
      console.log(reason.OPERATOR_KEY);
      let vesselPermitOptions = getPermitOptions(
        this.props.validations.validations.permit,
        this.props.auth.vessel_entitlements,
        this.props.auth.operator_entitlements,
        reason.OPERATOR_KEY
      );
      let newState = {
        operator_permit_number: reason.OPERATOR_KEY,
        operator_first_name: reason.NAME_FIRST,
        operator_middle_name: reason.NAME_MIDDLE,
        operator_last_name: reason.NAME_LAST,
        vessel_permit_options: vesselPermitOptions,
      };

      if (reason.hasOwnProperty("NAME_EXT")) {
        newState.operator_ext_name = reason.NAME_EXT;
      }
      this.setState(newState);
    }
  } else {
    let vesselPermitOptions = getPermitOptions(
      this.props.validations.validations.operator,
      this.props.auth.vessel_entitlements,
      this.props.auth.operator_entitlements,
      null
    );
    this.setState({
      operator_permit_number: "",
      operator_first_name: "",
      operator_middle_name: "",
      operator_last_name: "",
      operator_ext_name: "",
      vessel_permit_options: vesselPermitOptions,
    });
  }
};

export const handleTripOperatorPreferenceChange = function (event) {
  event.preventDefault();
  console.log(event.currentTarget.dataset);
  let { operatorKey, nameFirst, nameMiddle, nameLast, nameExt, field } =
    event.currentTarget.dataset;

  if (!operatorKey) {
    console.log("No vessel operator value provided");
    return;
  }
  if (!field) {
    console.error("No field provided");
    return;
  }

  let newState = {};
  newState.operator_permit_number = operatorKey;
  newState.operator_first_name = nameFirst;
  newState.operator_middle_name = nameMiddle;
  newState.operator_last_name = nameLast;
  newState.operator_ext_name = nameExt;
  console.info("prefOperatorchange", newState);

  this.setState(newState);
};

export const setTripTypeState = function (newReportTripType) {
  const types = this.props.validations.validations.reportTripType;
  const newReportType = getReportType(newReportTripType, types);
  const newTripType = getTripType(newReportTripType, types);
  const newDisplayTripType = getDisplayTripType(newReportType, newTripType, types);
  let newState = {};
  newState.currentType = newReportTripType;
  newState.report_type = newReportType;
  newState.trip_type = newTripType;
  newState.display_trip_type = newDisplayTripType;
  newState.showNrCrewField = getShowCrewField(newTripType);
  newState.showNrAnglersField = getShowAnglerField(newTripType);
  this.setState(newState);
};

export const dateLandNowHandler = function (event) {
  event.preventDefault();
  let d = moment();
  const format = "DD-MMM-YY LT";
  let newState = {};
  newState.date_land = d.format("YYMMDDHHmm");
  newState.display_date_land = d.format(format);
  this.setState(newState);
  console.info(newState);
};

export const sailDateNowHandler = function (event) {
  event.preventDefault();
  let d = moment();
  const format = "DD-MMM-YY LT";
  let newState = {};
  newState.date_sail = d.format("YYMMDDHHmm");
  newState.display_date_sail = d.format(format);
  this.setState(newState);
  console.info(newState);
};

export const handleTripPermitPreferenceChange = function (event) {
  event.preventDefault();
  console.log(event.currentTarget.dataset);
  let { pnum, hullId, vesName, field } = event.currentTarget.dataset;

  if (!pnum) {
    console.log("No vessel permit value provided");
    return;
  }
  if (!field) {
    console.error("No field provided");
    return;
  }

  let newState = {};
  newState.vessel_name = vesName;
  newState.vessel_registration = hullId;
  newState.vessel_permit_num = pnum;
  console.info("prefVesselchange", newState);

  this.setState(newState);
};

export const handlePermitChange = function (event, reason) {
  console.log("permit_change_event", event);
  console.log("permit_change_reason", reason);
  if (reason) {
    //Save the new values when selected
    if (
      reason.hasOwnProperty("PNUM") &&
      reason.hasOwnProperty("HULL_ID") &&
      reason.hasOwnProperty("VES_NAME")
    ) {
      this.setState({
        vessel_permit_num: reason.PNUM,
        vessel_registration: reason.HULL_ID,
        vessel_name: reason.VES_NAME,
      });
    }
  } else {
    //If emptied then empty the state
    this.setState({
      vessel_permit_num: "",
      vessel_registration: "",
      vessel_name: "",
    });
  }
};

export const handleDateLandChange = function (date) {
  console.log("landDate", date);
  if (date && date.hasOwnProperty("_d")) {
    let newDateTime = date._d;
    if (newDateTime !== "") {
      const dt = moment(newDateTime, "DD-MM-YYYY LT");
      const bDateTime = dt.format("YYMMDDHHmm");
      console.log("date_land", newDateTime);
      console.log("date_land", bDateTime);
      this.setState({
        display_date_land: newDateTime,
        date_land: bDateTime,
      });
    } else {
      this.setState({ display_date_land: newDateTime, date_land: "" });
    }
  }
};

export const handleSailDateChange = function (date) {
  if (date && date.hasOwnProperty("_d")) {
    let newDateTime = date._d;
    if (newDateTime !== "") {
      const dt = moment(newDateTime, "DD-MM-YYYY LT");
      let bDateTime = dt.format("YYMMDDHHmm");
      console.log("date_sail", newDateTime);
      console.log("date_sail", bDateTime);
      this.setState({
        display_date_sail: newDateTime,
        date_sail: bDateTime,
      });
    } else {
      this.setState({ display_date_sail: newDateTime, date_sail: "" });
    }
  }
};

export const getTripTripId = function (tripObject) {
  if (
    !tripObject ||
    !tripObject.hasOwnProperty("trip") ||
    !tripObject.trip.hasOwnProperty("trip_id")
  ) {
    console.error("No tripobject or no trip_id presented", tripObject);
    return false;
  }
  return tripObject.trip.trip_id;
};

export const getCurrentOpenTrip = function (allOpenTrips, tripId) {
  if (allOpenTrips && Array.isArray(allOpenTrips)) {
    for (let e = 0; e < allOpenTrips.length; e++) {
      if (allOpenTrips[e].trip_id === tripId) {
        return allOpenTrips[e];
      }
    }
  }
  return false;
};

export const getDecryptKey = function (client_id) {
  let key = [];
  let counter = 0;
  const padString = "WeAlwaysLoveFishSustainableCaught";
  const keyPass = client_id.padEnd(32, padString).substring(0, 32);
  for (const i of keyPass) {
    key[counter] = i.charCodeAt();
    counter++;
  }
  return key;
};

export const decryptEncryptValue = function (inputValue, client_id, encrypt_decrypt) {
  if (encrypt_decrypt === ENCRYPT_VALUE) {
    return generateEncryptedValue(inputValue, client_id);
  }
  if (encrypt_decrypt === DECRYPT_VALUE) {
    return generateDecryptValue(inputValue, client_id);
  }
};

export const generateEncryptedValue = function (inputValue, client_id) {
  if (inputValue) {
    let aesjs = require("aes-js");
    // Convert text to bytes
    let text = inputValue;
    let textBytes = aesjs.utils.utf8.toBytes(text);

    // The counter is optional, and if omitted will begin at 1
    let aesCtr = new aesjs.ModeOfOperation.ctr(
      getDecryptKey(client_id),
      new aesjs.Counter(9)
    );
    let encryptedBytes = aesCtr.encrypt(textBytes);

    // To print or store the binary data, you may convert it to hex
    let encryptedHex = aesjs.utils.hex.fromBytes(encryptedBytes);
    return encryptedHex;
  }
  return null;
};

export const generateDecryptValue = function (encryptedHex, client_id) {
  if (encryptedHex) {
    let aesjs = require("aes-js");
    let encryptedBytes = aesjs.utils.hex.toBytes(encryptedHex);
    // The counter mode of operation maintains internal state, so to
    // decrypt a new instance must be instantiated.
    let aesCtr = new aesjs.ModeOfOperation.ctr(
      getDecryptKey(client_id),
      new aesjs.Counter(9)
    );
    let decryptedBytes = aesCtr.decrypt(encryptedBytes);
    // Convert our bytes back into text
    let decryptedText = aesjs.utils.utf8.fromBytes(decryptedBytes);
    return decryptedText;
  }
  return "";
};

export const replaceTrip = function (tripHeader, efforts, sales) {
  let newTripObject = new TripEncRow();
  newTripObject.setTripId(tripHeader.trip_id);
  newTripObject.setDateSail(tripHeader.date_sail);
  newTripObject.setDateLand(tripHeader.date_land);
  newTripObject.setNoEffortTripReason(tripHeader.no_effort_trip_reason);
  newTripObject.setNumberOfAnglers(tripHeader.number_of_anglers);
  newTripObject.setNumberOfCrew(tripHeader.number_of_crew);
  newTripObject.setOperatorFirstName(tripHeader.operator_first_name);
  newTripObject.setOperatorLastName(tripHeader.operator_last_name);
  newTripObject.setOperatorPermitNumber(tripHeader.operator_permit_number);
  newTripObject.setOperatorExtName(tripHeader.operator_ext_name);
  // * Added a default value for trips submitted before Clam/Lobster feature release.
  if (!("report_type" in tripHeader)) {
    newTripObject.setReportType("1");
    if (tripHeader.hasOwnProperty("trip_type")) {
      if (tripHeader.trip_type === "1") {
        newTripObject.setDefaultUOM("LBS");
        newTripObject.setDefaultSpeciesUOM("LBS");
      } else {
        newTripObject.setDefaultUOM("CNT");
        newTripObject.setDefaultSpeciesUOM("CNT");
      }
    }
  } else {
    newTripObject.setReportType(tripHeader.report_type);
  }
  if (tripHeader.hasOwnProperty("default_uom")) {
    newTripObject.setDefaultUOM(tripHeader.default_uom);
  }
  if (tripHeader.hasOwnProperty("default_species_uom")) {
    newTripObject.setDefaultSpeciesUOM(tripHeader.default_species_uom);
  }
  newTripObject.setTripType(tripHeader.trip_type);
  newTripObject.setVesselPermitNum(tripHeader.vessel_permit_num);
  newTripObject.setSubmissionType(tripHeader.submission_type);
  newTripObject.setLowestSerialNum(tripHeader.lowest_serial_num);
  newTripObject.setTripStatus(tripHeader.trip_status);
  if (newTripObject.getReportType() === "2") {
    newTripObject.setBuoyLines(tripHeader.lines_in_water_total);
    newTripObject.setTrapsPerString(tripHeader.avg_traps_per_string);
    newTripObject.setTrapsInWater(tripHeader.traps_in_water_total);
  }
  //TODO fix this in base_api
  if (tripHeader.vessel_name === null && tripHeader.vessel_permit_num === "555555") {
    newTripObject.setVesselName("Sustainable Catch");
    newTripObject.setVesselRegistration("TEST1111");
  } else {
    newTripObject.setVesselName(tripHeader.vessel_name);
    newTripObject.setVesselRegistration(tripHeader.vessel_registration);
  }
  let tripSubtrips = [];
  if (Array.isArray(efforts)) {
    tripSubtrips = efforts;
  }

  if (tripSubtrips.length > 0) {
    let savedSubtripsArray = [];
    const NrSubtrips = tripSubtrips.length;
    for (let e = 0; e < NrSubtrips; e++) {
      let subTrips = new EffortEncRow();
      subTrips.setChartArea(tripSubtrips[e].chart_area);
      subTrips.setGearCode(tripSubtrips[e].gearcode);
      // Can we skip this? subTrips.setGearName()
      subTrips.setMeshSize(tripSubtrips[e].mesh_size);
      subTrips.setGearQty(tripSubtrips[e].gearqty);
      subTrips.setGearSize(tripSubtrips[e].gearsize);
      //TODO handle in case not being Decimal Degrees
      subTrips.setLanLongFormat("Decimal Degrees");
      let longitude = {};
      longitude.decimal_degrees = tripSubtrips[e].longitude_or_loran2;
      longitude.degrees_decimal_minutes = { degrees: "", minutes: "" };
      longitude.degrees_minutes_seconds = {
        degrees: "",
        minutes: "",
        seconds: "",
      };
      let latitude = {};
      latitude.decimal_degrees = tripSubtrips[e].latitude_or_loran1;
      latitude.degrees_decimal_minutes = { degrees: "", minutes: "" };
      latitude.degrees_minutes_seconds = {
        degrees: "",
        minutes: "",
        seconds: "",
      };
      subTrips.setLongitude(longitude);
      subTrips.setLatitude(latitude);
      subTrips.setNumberOfHauls(tripSubtrips[e].number_of_hauls);
      subTrips.setFishingDepth(tripSubtrips[e].fishing_depth);
      let rawSoakTime = tripSubtrips[e].tow_soak_time;
      if (rawSoakTime && rawSoakTime.includes(":")) {
        let soakTime = rawSoakTime.split(":");
        let soakHrs = soakTime[0];
        let soakMinutes = soakTime[1];
        subTrips.setSoakTime(soakHrs, soakMinutes);
      }
      // TODO: check if it's working correctly
      subTrips.setSerialNum(tripSubtrips[e].serial_num);
      if (
        newTripObject.getReportType() === "2" &&
        ["PTLL", "PTCL"].includes(tripSubtrips[e].gearcode)
      ) {
        subTrips.setNumTrapsHauled(tripSubtrips[e].traps_per_effort);
        subTrips.setNumTrapsInWater(tripSubtrips[e].traps_in_water_per_area);
        subTrips.setNumTrapsPerString(tripSubtrips[e].traps_per_string_per_area);
        subTrips.setNumBuoyLines(tripSubtrips[e].lines_in_water_per_area);
        subTrips.setStringsHauled(tripSubtrips[e].strings_hauled_per_effort);
        subTrips.setAvgSoakTime(tripSubtrips[e].avg_soak_time_per_effort);
      } else {
        subTrips.setNumTrapsHauled("");
        subTrips.setNumTrapsInWater("");
        subTrips.setNumTrapsPerString("");
        subTrips.setNumBuoyLines("");
        subTrips.setStringsHauled("");
        subTrips.setAvgSoakTime("");
      }
      let subTripCatch = tripSubtrips[e].catch;
      let catches = [];
      for (let i = 0; i < subTripCatch.length; i++) {
        let c = new CatchEncRow();
        c.setSpecies(subTripCatch[i].species);
        c.setUom(subTripCatch[i].uom);
        c.setKept(subTripCatch[i].kept);
        c.setDiscarded(subTripCatch[i].discarded);
        catches[catches.length] = c;
      }
      subTrips.setCatch(catches);
      savedSubtripsArray[savedSubtripsArray.length] = subTrips;
    }
    newTripObject.images = savedSubtripsArray;
    let tripSales = [];
    let tripSalesLength = 0;
    if (Array.isArray(sales)) {
      tripSales = sales;
      if (Array.isArray(tripSales)) {
        tripSalesLength = tripSales.length;
      }
    }
    if (tripSalesLength > 0) {
      let sales = [];
      for (let a = 0; a < tripSalesLength; a++) {
        sales[sales.length] = getSalesRow(tripSales[a]);
      }
      newTripObject.sales = sales;
      console.log(newTripObject);
    }
  }
  return newTripObject;
};
